<template>
    <div class="col-md-12">
        <div class="card">
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="listBusiness"><strong>{{$t("negocio")}}</strong></label>
                        <el-select class="select-default"
                                   size="large"
                                   :value="xidBusiness"
                                   filterable
                                   @change="setBusiness"
                                   :placeholder="$t('seleccionaNegocio')">

                            <el-option v-for="business in xlistBusiness"
                                       class="select-primary"
                                       :value="business.id"
                                       :label="business.establishmentName"
                                       :key="business.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">

                        <label for="listTPV"><strong>{{$t("TPV")}}</strong></label>

                        <div class="row">
                            <div class="col-8">
                                <el-select class="select-default"
                                           size="large"
                                           :value="xidTpv"
                                           filterable
                                           @change="setIdTpv"
                                           :placeholder="$t('seleccionaTpv')">
                                    <el-option v-for="tpv in xlistTpv"
                                               class="select-primary"
                                               :value="tpv.id"
                                               :label="tpv.nameShow"
                                               :key="tpv.id">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="col-4">
                                <button @click="openModal" class="btn btn-primary">
                                    <i class="fa fa-filter"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-md-2">
                    <div class="form-group">
                        <label><strong>{{$t("fechaInicio")}}</strong></label>
                        <datetime
                                value-zone="Europe/Madrid"
                                :auto="true"
                                class="theme-numier"
                                format="dd-MM-yyyy"
                                @input="setfechaDesde"
                                :title="$t('fechaInicio')"
                                :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                input-class="form-control"
                                :value="xFechaDesde"></datetime>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="form-group">
                        <label><strong>{{$t("fechaFin")}}</strong></label>
                        <datetime
                                value-zone="Europe/Madrid"
                                :auto="true"
                                class="theme-numier"
                                :title="$t('fechaFin')"
                                format="dd-MM-yyyy"
                                @input="setFechaHasta"
                                :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                input-class="form-control"
                                :value="xFechaHasta"></datetime>
                    </div>
                </div>
                <div class="col-md-2">
                    <label>&nbsp;</label>
                    <div class="form-group">
                        <button class="btn btn-primary" @click="changeRespuesta(false),$emit('getDatos')">
                            <template v-if="!xRespuesta"><img src="static/img/sync.gif" alt="" width="15">
                            </template>
                            {{$t("consultar")}}
                        </button>
                    </div>
                </div>

                <!--    Modal TPVS-->
                <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                    <div>
                        <div class="modal-header">
                            <h4 style="margin: 0px">{{$t("filtrarPorTPV")}}</h4>
                        </div>
                        <div class="modal-body">

                            <el-checkbox-group :min="1" @input="asignarTpvId" :value="xlistIdsTpv" size="medium">
                                <el-checkbox v-for="tpv in xlistIdsTpvFiltro" :label=tpv.id :key="tpv.id" border>
                                    {{tpv.nameShow}}
                                </el-checkbox>
                            </el-checkbox-group>


                        </div>
                        <div class="modal-footer">
                            <div align="right" class="col-12">
                                <button class="btn btn-primary" @click="$emit('getDatos')"><i class="fa fa-search"></i>
                                    {{$t("filtrarTPV")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </modal>

            </div>
        </div>
    </div>
</template>

<script>

    import {
        DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'

    import Vuex from 'vuex';


    export default {
        name: "CabeceraInformes",
        
        computed: {
            ...Vuex.mapState(["xidTpv", "xidBusiness", "xlistBusiness", "xlistTpv", "xlistIdsTpv", "xlistIdsTpvFiltro", "xFechaDesde", "xFechaHasta", "xRespuesta"]),
        },
        methods: {
            ...Vuex.mapMutations(["changeTpv", "changeBusiness", "changeFechaDesde", "changeFechaHasta", "asignarIdTpv", "changeRespuesta"]),

            ...Vuex.mapActions(["cargarBusiness", "cargarTpvs"]),

            setIdTpv(val) {
                this.changeTpv(val)
            },
            setIdBusiness(val) {
                this.changeBusiness(val)
            },

            setfechaDesde(val) {

                this.changeFechaDesde(val)
            },
            setFechaHasta(val) {

                this.changeFechaHasta(val)
            },

            openModal() {
                this.$modal.show('filtradoTPV');

            },

            setBusiness(val) {

                this.changeBusiness(val);

                this.changeTpv('0');

                this.cargarTpvs()
            },

            asignarTpvId(val) {
                this.asignarIdTpv(val);
            },


        },

        watch: {

            xidTpv: function (val) {
                this.$emit('getDatos');
            }

        },

        created() {

            if (this.xidTpv && this.xidBusiness) {
                this.$emit('getDatos');
            }
        },

        data() {
            return {}
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    body {
        background: #1D1F20;
        padding: 16px;
    }

    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/CabeceraInformes.vue